import { render, staticRenderFns } from "./StScrolly.vue?vue&type=template&id=5c5f6419&"
import script from "./StScrolly.vue?vue&type=script&lang=js&"
export * from "./StScrolly.vue?vue&type=script&lang=js&"
import style0 from "./StScrolly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports